import { render, staticRenderFns } from "./view-information.vue?vue&type=template&id=224761ec&scoped=true&"
import script from "./view-information.vue?vue&type=script&lang=js&"
export * from "./view-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224761ec",
  null
  
)

export default component.exports